<template>
  <div v-for="error in errors" :key="error.key">
    <p class="leadMsg" id="outMessageCase">
      <span class="newline errorMsg-color">
        {{ error.message }}
      </span>
    </p>
  </div>
</template>

<script>
export default {
  name: "ErrorMessageCase",
  props: {
    errors: {
      type: [Array],
      required: true,
    },
  },
  watch: {
    errors: function (newVal, oldVal) {
      if (newVal.length != 0) {
        window.scrollTo(0, 0);
      }
    },
  },
};
</script>
